export default "/_next/static/b2c255ba8c257e4d97ec932effd2c9ee.png";